export const dayStyle = a => {
    const day = a.getDay() === 0 || a.getDay() === 6; // Sunday (0) or Saturday (6)
    return day ? "sday" : "";
};
